<ng-container *ngIf="shippingGroup$ | async as shippingGroup">
  <cx-spinner *ngIf="loading === GenLoadingEnum.Loading" class="spinner-overlay"></cx-spinner>
  <gen-checkout-delivery-groups 
    [shippingGroup]="shippingGroup"
    [cartCode]="cartCode"
    [purchaseOrderNumber]="purchaseOrderNumber">
  </gen-checkout-delivery-groups>
  <gen-checkout-shipping-accounts-selector *ngIf="!daFreeShipping"
    [shippingAccountSelected]="selectedShippingAccount"
    [disableDealerShippingAccount]="isLtlItemExists || !dealerShippingAccounts || dealerShippingAccounts?.length < 0"
    [dealerShippingAccountsError]="shippingGroup?.dealerShippingAccountsError"
    (shippingAccountChanged)="getDeliveryMethods($event)"
  ></gen-checkout-shipping-accounts-selector>
  <gen-checkout-delivery-method-selector *ngIf="!daFreeShipping"
    [updateDeliveryMethods]="updateDeliveryMethodsTrigger$"
    [generacShippingAccounts]="generacShippingAccounts"
    [dealerShippingAccounts]="dealerShippingAccounts"
    [selectedCarrier]="selectedCarrier"
    [selectedShippingCondition]="selectedShippingCondition"
    (carrierOptionSelected)="setCarrier($event)"
  ></gen-checkout-delivery-method-selector>
  <gen-checkout-special-handling [shippingGroupName]="shippingGroup.shippingGroupName">
  </gen-checkout-special-handling>
</ng-container>

<gen-checkout-control-btns
  [isContinueDisabled]="!selectedCarrier || !selectedShippingCondition || !selectedShippingAccount || loading === GenLoadingEnum.Loading"
  [isNextActionCustom]="true"
  [skipPaymentTypeStep]="skipPaymentTypeStep"
  (nextBtnClicked)="next()">
</gen-checkout-control-btns>